import type { AnnotationLabelT } from '../../../../common/types/types';
import { CUSTOM_TOOLS, TOOL } from '../../constants';
import type { AnnotationType, ToolT } from '../../types';
export const getAvailableTools = (annotationLabel?: AnnotationLabelT | null): ToolT[] => {
  if (annotationLabel?.tools && annotationLabel.tools.length > 0) {
    return ((annotationLabel.tools ?? []).filter(tool => !(tool in CUSTOM_TOOLS)) as ToolT[]);
  }
  return Object.values(TOOL);
};
export const getSelectedTool = (currentTool: ToolT, availableTools: ToolT[]): ToolT => {
  if (currentTool && availableTools.includes(currentTool)) {
    return currentTool;
  }
  return availableTools[0] ?? TOOL.POINTER;
};
export const getToolsForAnnotation = (annotationType: AnnotationType): ToolT => {
  switch (annotationType) {
    case 'CUBOID':
      {
        return TOOL.CUBOID;
      }
    case 'ELLIPSE':
      {
        return TOOL.ELLIPSE;
      }
    case 'FRAME_CLASSIFICATION':
      {
        return TOOL.GRID;
      }
    case 'KEY_POINT':
      {
        return TOOL.KEY_POINT;
      }
    case 'POLYGON':
      {
        return TOOL.POLYGON;
      }
    case 'POLYLINE':
      {
        return TOOL.POLYLINE;
      }
    case 'RECTANGLE':
      {
        return TOOL.RECTANGLE;
      }
    case 'SEGMENTATION':
      {
        return TOOL.SEGMENTATION;
      }
    case 'SKELETON':
      {
        return TOOL.SKELETON;
      }
  }
};